<template>
    <!-- 提示信息组件 -->
    <el-tooltip 
    :effect="effect" 
    :content="content" 
    :placement="placement">
        <template #content>
            <slot name="content"></slot>
        </template>
        <slot ></slot>
    </el-tooltip>
</template>
<script>
export default {
    name:"VelTips",
    props:{
        effect:{
            type:String,
            default:'light'
        },
        content:String,
        placement:{
            type:String,
            default:'top'
        },
    },
    data() {
        return {
            
        };
    }
}
</script>
<style>
.el-tooltip__popper,
.el-tooltip__popper.is-dark{
    max-width:20%;
}
</style>